import {renderClient} from '../main';
import {applyInitialTheme} from '../ui/style/theme-preference';

const initClient = () => {
  try {
    applyInitialTheme();
    renderClient();
  } catch (e: any) {
    throw new Error(e);
  }
};

initClient();
